var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setting-header"},_vm._l((_vm.tabs),function(tab,index){return _c('router-link',{key:index,class:tab.name === _vm.$route.name && 'active',attrs:{"to":{ name: tab.name }}},[_vm._v(" "+_vm._s(_vm.$t(tab.label))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }